<template>
    <div>
        <template v-if="!error">
            <ContentOrLoading style="min-height: 500px;">
                <b-row v-if="reserva && !butacasEnSesion && !comprado">
                    <b-col cols="12">
                        <PageTitle title=""/>
                        <CabeceraClubs
                            v-if="reserva.evento.equipo_local"
                            :event="reserva.evento"
                        />
                        <CabeceraImagen
                            v-if="!reserva.evento.equipo_local"
                            :event="reserva.evento"
                            :sesion="reserva.sesion"
                        />
    
                        <Stepper
                            ref="stepper"
                            :steps="steps" 
                        >
                            <template #seleccionZona="{ changeStep }">
                                <div class="container">
                                    <div cols="12" v-if="! zona_seleccionada">
                                        <SeleccionarZonaComponent 
                                            id="selectorZona"
                                            :reserva="reserva"
                                            :zonas_disponibles="zonas_disponibles"
                                            @seleccionarZona="(seats, zona) => { seat_map = seats; zona_seleccionada = zona; changeStep() }"
                                        />
                                    </div>
                                </div>
                            </template>

                            <template #seleccionAsientos="{ changeStep }">
                                <div class="container">
                                    <div cols="12" v-if="! asientos_seleccionados && zona_seleccionada">
                                        <SeleccionarAsientosComponent
                                            :reserva="reserva"
                                            :zona_seleccionada="zona_seleccionada"
                                            :seat_map="seat_map"
                                            :asientos.sync="asientos"
                                            @resetAsientos="resetAsientos"
                                            @asientosSeleccionados="() => { asientos_seleccionados = true; changeStep() }"
                                        />
                                    </div>
                                </div>
                            </template>
            
                            <template #datosCompradores>
                                <div class="container">
                                    <div class="row">
                                        <div class="col-12 pb-5">
                                            <DatosCompradoresComponent
                                                :datos_compradores="datos_compradores" 
                                                :generos="generos" 
                                                :solicitar_datos="reserva.evento.solicitar_datos"
                                                :reserva_instalaciones="reserva.evento.reserva_instalaciones"
                                                :asientos="asientos"
                                                :plazas="entradasPlazas"
                                                :desactivar="resumen"
                                                :lfp="false"
                                                @terminar="guardarDatos"
                                                @cambiar-asiento="resetAsientos"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template #resumenCompra="{ changeStep }">
                                <div class="container pb-5">
                                    <div class="row">
                                        <div class="col-12">
                                            <h2 class="m-0 h1 text-uppercase">
                                                {{ $t('partido.resumen_compra') }}
                                            </h2>
                                            <div class="subtitle h3 light mb-3 mb-lg-5">
                                                {{ $t('partido.revisa_datos') }}.
                                            </div>
                                            <ResumenCompraComponent 
                                                :entradas="asientos"
                                                :entradasPlazas="entradasPlazas"
                                                :formulario="formulario"
                                                :event="reserva.evento"
                                                :datos="datos_compradores"
                                                :session_id="session_id"
                                                @terminado="procesarPago"
                                                @volver="() => { asientos_seleccionados = true; changeStep(true); borrarSesion() }"
                                                :desactivar="procesar_pago ? true : false"
                                                :voucher="voucher"
                                            />					
                                        </div>
                                    </div>
                                </div>
                            </template>
            
                            <template #pago>
                                <div class="container">
                                    <div class="row">
                                        <div class="col-12">
                                            <h2 class="m-0 h1 text-uppercase">
                                                {{ $t('compra.confirmacion_compra') }}
                                            </h2>
                                            <div class="subtitle h3 light mb-3 mb-lg-5">
                                                {{ $t('compra.introduce_datos') }}
                                            </div>
                                            <PagoPaycometComponent
                                                ref="pago"
                                                tipo_venta="evento"
                                                :jet_id="jet_id"
                                                :session_id="session_id"
                                            />		
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </Stepper>
                    </b-col>
                </b-row>
                <b-row v-if="butacasEnSesion">
                    <b-col cols="12">
                        <PageTitle title="Ha interrumpido el proceso de compra. Por favor, vuelva a intentarlo en 15 minutos."/>
                    </b-col>
                </b-row>
                <b-row v-if="comprado">
                    <b-col cols="12">
                        <PageTitle title="Ya se han comprado las entradas de este enlace."/>
                    </b-col>
                </b-row>
            </ContentOrLoading>
        </template>
        <b-col v-else>
            <NotFoundComponent/>
        </b-col>
    </div>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import NotFoundComponent from '@/components/frontend/errors/NotFoundComponent.vue';
    import CabeceraClubs from '@/components/frontend/events/show/CabeceraClubs.vue';
    import CabeceraImagen from '@/components/frontend/events/show/CabeceraImagen.vue';
    import DatosCompradoresComponent from '@/components/frontend/events/compra/DatosCompradoresComponent.vue';
    import ResumenCompraComponent from '@/components/frontend/events/compra/ResumenCompraComponent';
    import PagoPaycometComponent from '@/components/frontend/compra/components/PagoPaycometComponent.vue';
    import SeleccionarZonaComponent from '@/components/frontend/reservas/SeleccionarZonaComponent.vue';
    import SeleccionarAsientosComponent from '@/components/frontend/reservas/SeleccionarAsientosComponent.vue';
    import Stepper from '@/components/frontend/events/compra/components/Stepper.vue';

    export default {
        props: ['hash'],
        data() {
            return {
                reserva: null,
                error: false,
                datos_compradores: {},
                asientos: [],
                entradasPlazas: [],
                jet_id: null,
                formulario: null,
                resumen: false,
                session_id: null,
                procesar_pago: false,
                voucher: null,
                comprado: false,
                asientos_seleccionados: false,
                zona_seleccionada: null,
                seat_map: [],
                steps: [],
                butacasEnSesion: false
            }
        },
        created() {
            this.getInfoReserva();
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            zonas_disponibles() {
                return this.reserva?.zonas.filter(zona => zona.esta_disponible);
            },
            generos() {
                return this.$store.getters.getGeneros;
            }
        },
        methods: {
            buildSteps() {
                this.steps = [];
                if (!this.zona_seleccionada) {
                    this.steps.push({ label: this.$t('afiliados.seleccionar_zona'), slot: "seleccionZona" });
                    this.steps.push({ label: this.$t('afiliados.seleccionar_asientos'), slot: "seleccionAsientos" });
                } else if (!this.asientos_seleccionados) {
                    this.steps.push({ label: this.$t('afiliados.seleccionar_asientos'), slot: "seleccionAsientos" });
                }
            
                this.steps.push({ label: this.$t('afiliados.datos_comprador'), slot: "datosCompradores" });
                this.steps.push({ label: this.$t('afiliados.resumen'), slot: "resumenCompra" });
                this.steps.push({ label: this.$t('afiliados.pago'), slot: "pago" });
            },
            getInfoReserva() {
                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro
                    },
                    hash: this.hash
                };
                this.$store.dispatch(this.config.getVuexAlias('front.reservas.info'), params).then(res => {
                    this.reserva = res.data.data;

                    if(this.reserva.butacas.length == 0 && this.reserva.plazas.length == 0) {
                        this.butacasEnSesion = true;
                    }

                    if(this.reserva.comprar_completa) {
                        if (this.reserva.butacas && this.reserva.butacas.length > 0) {
                            this.reserva.butacas.forEach(butaca => {
                                this.asientos.push({
                                    asiento: butaca,
                                    precios: butaca.precios,
                                    descuento: this.reserva.descuento,
                                    precio: butaca.precio
                                })
                            });
                        }

                        if (this.reserva.plazas && this.reserva.plazas.length > 0) {
                            this.reserva.plazas.forEach(butaca => {
                                butaca.descuento = this.reserva.descuento;
                                this.asientos.push(butaca);
                            });
                        }

                        this.asientos_seleccionados = true;
                        this.zona_seleccionada = true;
                    } else {
                        if(this.zonas_disponibles.length == 1) {
                            this.zona_seleccionada = this.zonas_disponibles[0];
                            this.seat_map = this.reserva.seat_map.find(zona_map => zona_map.region_id === this.zona_seleccionada.id).asientos;
                        }
                    }         

                    if (this.configuracion.hash_teatro !== 'UHmERrsRV19JCGQMg7Is') {
                        this.datos_compradores.email = this.reserva.email;
                    }

                    if(this.reserva.descuento) {
                        this.voucher = {
                            discount_percent: this.reserva.descuento,
                            units: 100,
                            code: 'Venta personalizada'
                        }
                    }
                    this.buildSteps();

                }).catch(error => {
                    if(error.response.status == 400) {
                        this.comprado = true;
                    } else {
                        this.error = true;
                    }                
                });            
            },
            guardarDatos() {
                this.resumen = true;

                this.asientos.forEach(asiento => {
                    if (asiento.precio === null) {
                        asiento.precio = asiento.precioSeleccionado;
                    }
                });
                this.datos_compradores.asientos = this.asientos;

                let params = {
                    filters: {
                        tid: this.configuracion.hash_teatro
                    },
                    hash: this.hash,
                    datos_compradores: this.datos_compradores,
                    session_id: this.session_id
                };

                if (this.reserva.plazas.length > 0) {
                    params.plazas = this.asientos;
                } else {
                    params.butacas = this.asientos;
                }

                const cookie = this.$cookies.get('comunicados-track-id');

                if(cookie) {
                    params.token_comunicado = cookie;
                }

                this.$store.dispatch(this.config.getVuexAlias('front.reservas.guardar.datos'), params).then(res => {
                    if(res.data.error) {
                        this.$toast.error(res.data.message);
                        this.resetAsientos();
                        this.getInfoReserva();
                    } else {
                        this.jet_id = res.data.jet_id;
                        this.session_id = res.data.data.session_id;
                        this.formulario = res.data.formulario;
                        this.$nextTick(() => {
                            if (this.$refs.stepper) {
                                this.$refs.stepper.changeStep();
                            }
                        });
                    }
                }).catch(error => {
                    this.$toast.error("Los asientos seleccionados no están disponibles o se ha producido un error");
                    this.resetAsientos();
                    this.getInfoReserva();
                }).finally(() => this.resumen = false);
            },
            volver() {
                this.resumen = false;
                this.borrarSesion();
                this.asientos_seleccionados = true;
            },
            borrarSesion() {
                const params = {
                    filters: {
                        session_id: this.session_id,
                        tid: this.configuracion.hash_teatro
                    },
                    session_id: this.session_id,
                    tid: this.configuracion.hash_teatro
                }

                this.$store.dispatch(this.config.getVuexAlias('front.sesion.delete'), params);
            },
            procesarPago(precio_cero = false) {
                if (precio_cero) {
                    this.procesarCompraPrecioCero();
                } else {
                    this.procesar_pago = true;
                    this.$nextTick(() => {
                        if (this.$refs.stepper) {
                            this.$refs.stepper.changeStep();
                        }
                    });
                }
            },
            procesarCompraPrecioCero() {
                const params = {
                    filters: {},
                    carrito_id: this.session_id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.events.procesar-compra-precio-cero'), params).then(res => {
                    this.$router.push(`/compra/${this.session_id}/${res.data.n_pedido}`);
                }).finally(() => this.loading = false);
            },
            resetAsientos() {
                if(! this.reserva.comprar_completa) {
                    this.seat_map = [];
                    this.zona_seleccionada = null;
                    this.asientos = [];
                    this.asientos_seleccionados = false;
                    this.$refs.stepper.resetStepper();
                }            
            }
        },
        components: {
            PageTitle, NotFoundComponent, CabeceraClubs, CabeceraImagen, DatosCompradoresComponent, ResumenCompraComponent, PagoPaycometComponent,
            SeleccionarZonaComponent, SeleccionarAsientosComponent, Stepper
        }
    }
</script>